import cn from "classnames";
import "./TabButtonMobile.scss";
import { ColorTheme } from "/Models/Models/ColorTheme";
import { CaretDownIcon, CaretUpIcon } from "/App.Components";

interface Props {
  text?: string;
  selected?: boolean;
  onClick: () => void;
  isFirst?: boolean;
  isLast?: boolean;
  chevronOpen?: boolean;
  chevronClosed?: boolean;
}

const TabButtonMobile = ({
  text,
  selected,
  onClick,
  isFirst,
  isLast,
  chevronClosed,
  chevronOpen,
}: Props) => (
  <button
    onClick={onClick}
    className={cn("tab-button-mobile-norad", {
      "tab-button-mobile-norad--is-first": isFirst,
      "tab-button-mobile-norad--is-last": isLast,
    })}
  >
    <span
      className={cn("tab-button-mobile-norad__text", {
        "tab-button-mobile-norad__text--selected": selected,
      })}
    >
      {text}
    </span>
    {(chevronOpen || chevronClosed) && (
      <span className="tab-button-mobile-norad__icon">
        {chevronClosed && (
          <CaretDownIcon
            size="24"
            thickness="Reg"
            color={ColorTheme.iconStrong}
          />
        )}
        {chevronOpen && (
          <CaretUpIcon
            size="24"
            thickness="Reg"
            color={ColorTheme.iconStrong}
          />
        )}
      </span>
    )}
  </button>
);
export default TabButtonMobile;
